var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
/**
 * Properties order: handle;sku;size:variantId
*/
var LOCAL_STORAGE_PROPERTIES_DELIMITER = ';';
var BUTTON_ACTIVE_CLASS = 'active';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

document.addEventListener('DOMContentLoaded', function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) { setupButtons(buttons); }
  var grid = document.querySelector(selectors.grid) || false;
  if (grid) { setupGrid(grid); }
  updateWishlistCount(true);
});

var setupGrid = async function (grid) {
  var wishlist = await getWishlist();
  var requests = wishlist.map(async function (item) {
    var productTileTemplateUrl = '/products/' + item.handle + '?view=card';
    const res = await fetch(productTileTemplateUrl);
    return await res.text();
  });

  Promise.all(requests).then(function (responses) {
    updateWishlistCount();
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    var buttons = grid.querySelectorAll(selectors.button) || [];
    if (buttons.length) { setupButtons(buttons); }
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) { return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.'); }
    wishlistContains(productHandle) ? button.classList.add(BUTTON_ACTIVE_CLASS) : button.classList.remove(BUTTON_ACTIVE_CLASS);
    if (button.hasAttribute("click-listener")) { return; }

    button.addEventListener('click', function () {
      updateWishlist(productHandle, button.dataset.sku, button.dataset.size, button.dataset.variantId);
    });
    button.setAttribute("click-listener", "");
  });
};

var getWishlist = async function (forceRefresh = false) {
  if (!window.dbWishlist) {
    return getLocalWishlist();
  } else {
    await window.dbWishlist.ready;
    if ((window.dbWishlist.wishlist.length == 0) || forceRefresh) {
      await setWishlist(await window.dbWishlist.getWishlist(), false);
    }
    return window.dbWishlist.wishlist;
  }
}

var getLocalWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  let returnValue = [];
  if (wishlist) {
    const items = [];
    const wishlist_split = wishlist.split(LOCAL_STORAGE_DELIMITER);

    wishlist_split.forEach(item => {
      const properties = item.split(LOCAL_STORAGE_PROPERTIES_DELIMITER);
      if (item.length == 1) {
        items.push({
          handle: properties[0],
          sku: "",
          size: "Default Title",
          variantId: ""
        })
      } else {
        items.push({
          handle: properties[0],
          sku: properties[1],
          size: (properties[2] == "null") ? null : properties[2],
          variantId: properties[3]
        })
      }
    });
    returnValue = items;
  }
  return returnValue;
};

var setWishlist = async function (array, doRefresh = true) {
  if (window.dbWishlist) {
    window.dbWishlist.wishlist = array;
  }

  if (array.length) {
    let wishlist = "";
    for (let i = 0; i < array.length; i++) {
      const item = array[i];
      if (!item.variantId) {
        await fetch(`/products/${item.handle}?view=card`).then(res => {
          return res.text()
        }).then(html => {
          let parser = new DOMParser();
          let card = parser.parseFromString(html, 'text/html');
          let button = card.querySelector(selectors.button);
          item.sku = button.dataset.sku;
          item.size = button.dataset.size;
          item.variantId = button.dataset.variantId;
        });
      }
      const delimiter = LOCAL_STORAGE_PROPERTIES_DELIMITER;
      wishlist += `${item.handle}${delimiter}${item.sku}${delimiter}${item.size}${delimiter}${item.variantId}${LOCAL_STORAGE_DELIMITER}`
    }
    if (wishlist.length > 0) {
      wishlist = wishlist.slice(0, -1);
    }
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }

  if (doRefresh) {
    refreshWishList();
  } else {
    var buttons = document.querySelectorAll(selectors.button) || [];
    if (buttons.length) { setupButtons(buttons); }
  }
};

var updateWishlist = async function (handle, sku, size, variantId) {
  var wishlist = await getWishlist();
  //var indexInWishlist = wishlist.findIndex((item) => item.variantId == variantId);
  var indexInWishlist = wishlist.findIndex((item) => item.handle == handle);
  if (indexInWishlist === -1) {
    const newItem = {
      handle: handle,
      sku: sku,
      size: size,
      variantId: variantId
    };

    if (window.dbWishlist && await window.dbWishlist.ready) {
      await window.dbWishlist.addToWishlist(newItem).then(async (result) => {
        if (result.status == 201) {
          let id = (await result.json()).id;
          newItem.id = id;
          wishlist.push(newItem);
        }
      });
    } else {
      wishlist.push(newItem);
    }
  } else {
    if (window.dbWishlist && await window.dbWishlist.ready) {
      await window.dbWishlist.removeFromWishlist(wishlist[indexInWishlist]).then(result => {
        if (result.status == 200) {
          wishlist.splice(indexInWishlist, 1);
        }
      });
    } else {
      wishlist.splice(indexInWishlist, 1);
    }
  }
  setWishlist(wishlist);
  return wishlist;
};

var wishlistContains = function (handle) {
  return getLocalWishlist().findIndex((item) => item.handle == handle) !== -1;
};

var resetWishlist = function () {
  setWishlist([]);
  return [];
};

async function refreshWishList() {
  await getWishlist(true);
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) { setupButtons(buttons); }
  var grid = document.querySelector(selectors.grid) || false;
  if (grid) { setupGrid(grid); }
}


async function updateWishlistCount(fromLocal = false) {
  let wishlist_count_update_remove = fromLocal ? getLocalWishlist().length : (await getWishlist()).length;
  jQuery("span.wishlist-count-update").text(wishlist_count_update_remove);
  if (wishlist_count_update_remove >= 1) {
    jQuery(".wishlist-icon span.wishlist-count-update").show();
    jQuery(".wishlist-icon").addClass("fillsicon");
  } else {
    jQuery(".wishlist-icon span.wishlist-count-update").hide();
    jQuery(".wishlist-icon").removeClass("fillsicon");
  }
}

async function wishlistAddToCart(button) {
  button.setAttribute("disabled", "");
  const itemCard = button.closest(".item-details");
  let variantInput = itemCard.querySelector("select[name='id']");

    if (!variantInput) {
    variantInput = itemCard.querySelector("input[name='id'][type='hidden']");
  }
 
  if (!variantInput || variantInput.value == "") {
    wishlistShowSizeError(button, true);
    button.removeAttribute("disabled");
    return;
  }

  const addData = new FormData();
  addData.append('id', variantInput.value);
  addData.append('quantity', 1);
  await fetch("/cart/add", {
    method: "POST",
    body: addData
  });

  button.removeAttribute("disabled");
  if (refreshCart) {
    document.querySelector("#main-nav-wishlist .js-menu__close").click();
    refreshCart();
  }
}

function wishlistShowSizeError(elem, show) {
  const errorLabel = elem.closest(".item-details").querySelector(".wishlist-size-error");
  if (show) {
    errorLabel.classList.add("show");
  } else {
    errorLabel.classList.remove("show");
  }
}


$(document).ready(function ($) {
  $('.wishlist-drawer-header .js-menu__close').click(function () {
    refreshWishList();
  });

  $(document).on("click", ".js-menu__open_wishlist", function () {
    refreshWishList();
  });
});
